import React from 'react';
import { Box, Icon, Stack, Text, useColorMode, ButtonBase } from '@tonic-ui/react';

import styles from './questionnaire.module.css';

interface ConfirmationModalTileProps {
  serviceTitle: string;
  serviceMessage: string;
  service: string;
  onClick: (event: string) => void;
}

const ConfirmationModalTile = ({
  serviceTitle,
  serviceMessage,
  service,
  onClick,
}: ConfirmationModalTileProps): JSX.Element => {
  const [colorMode] = useColorMode();
  const colorModeClass = colorMode === 'dark' ? styles.dark : '';

  return (
    <ButtonBase
      padding="4x"
      display="flex"
      textAlign="left"
      className={`${styles.tile} ${colorModeClass}`}
      onClick={() => onClick(service)}
      data-id={`onboarding-service-${service}`}
      data-telemetry-id={`onboarding-service-${service}`}
    >
      <Stack spacing="2x">
        <Text marginBottom="2x" size="md" fontWeight="semibold">
          {serviceTitle}
        </Text>
        <Text size="sm">{serviceMessage}</Text>
      </Stack>
      <Box alignSelf="center" marginLeft="auto" paddingLeft="4x">
        <Icon icon="chevron-right" />
      </Box>
    </ButtonBase>
  );
};

ConfirmationModalTile.displayName = 'ConfirmationModalTile';

export default ConfirmationModalTile;
